import React from 'react';
import type { DiffPayloadV1 } from 'we-tree-api-client/v2';
import { formatDiffOpValue, getDiffPathLabel, formatDiffOpAction } from '@/types/suggestion';

import './suggestion-diff-preview.css';

interface SuggestionDiffPreviewProps {
  diffPayload: DiffPayloadV1;
  emptyMessage?: string;
}

const SuggestionDiffPreview: React.FC<SuggestionDiffPreviewProps> = ({
  diffPayload,
  emptyMessage = 'No field changes in this suggestion.'
}) => {
  const ops = diffPayload.ops ?? [];

  if (ops.length === 0) {
    return <p className="suggestion-diff-preview__empty">{emptyMessage}</p>;
  }

  return (
    <ul className="suggestion-diff-preview">
      {ops.map((op, index) => (
        <li key={`${op.path ?? op.op}-${index}`} className="suggestion-diff-preview__row">
          <span className="suggestion-diff-preview__label">{getDiffPathLabel(op.path, op.op, op.value)}</span>
          <span className="suggestion-diff-preview__op">{formatDiffOpAction(op.op)}</span>
          {op.op !== 'unset' && !op.op.startsWith('delete_') && (
            <span className="suggestion-diff-preview__value">{formatDiffOpValue(op.value, op.path, ops)}</span>
          )}
        </li>
      ))}
    </ul>
  );
};

export default SuggestionDiffPreview;
